/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import IO from 'socket.io-client';
import { format } from 'date-fns';

import { Col, Container, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useFormaPagamento } from '../../../hooks/formapagamento';

import ItemTabela from './ItemTabela';
import {
  formatPrice,
  SITUACAO_NOTA_FISCAL,
  TIPO_USUARIO,
} from '../../../utils/funcoes';
import { useAuth } from '../../../hooks/auth';
import { useNotaFiscal } from '../../../hooks/notafiscal';

export interface INotafiscal {
  CprCodigo: number;
  CprDataPag: string;
  FormaPagto: string;
  NfeCodigoVerificacao?: string;
  NfeCprCodigo?: number;
  NfeLinkNFSe?: string;
  NfeNumero: string;
  NfeSituacao: string;
  NumeroNF?: string;
  NfeNumeroNFSe?: string;
  NfeDataEmissao?: string;
  descricao: string;
  nome: string;
  vlr: number;
  vlrFormatado: string;
  linkNota?: string;
  NfeId?: string;
}

// const socket = io(document.getElementById('HidUrlAPI').value);
// const socket = IO('http://localhost:3333/', { query: { usu: 1 } });
const RelatorioNotaFiscal: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const { loading, notasFiscais, buscaNotas } = useNotaFiscal();

  const [txtDataIni, setTxtDataIni] = useState(
    format(new Date(), 'yyyy-MM-dd'),
  );
  const [txtDataFim, setTxtDataFim] = useState(
    format(new Date(), 'yyyy-MM-dd'),
  );

  const [cboFormaPagto, setCboFormaPagto] = useState('');
  const [cboData, setCboData] = useState('1');
  const [chkSituacao, setChkSituacao] = useState(false);

  const { optionsFormasPagamento, buscaFormaPagamento } = useFormaPagamento();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  useEffect(() => {
    async function loadFormaPagto(): Promise<void> {
      await buscaFormaPagamento();
    }
    if (
      !optionsFormasPagamento.optionFormaPagamento ||
      Object.keys(optionsFormasPagamento.optionFormaPagamento).length === 0
    )
      loadFormaPagto();
  }, [buscaFormaPagamento, optionsFormasPagamento]);

  const BuscaNota = useCallback(async (): Promise<void> => {
    const formaPagto = `&pagto=${cboFormaPagto}`;
    const dataTipo = `&dataTipo=${cboData}`;

    const requisicao = `rps/relatorioNotaFiscal?dataIni=${txtDataIni}&dataFim=${txtDataFim}&emitida=false${dataTipo}${formaPagto}`;

    buscaNotas(requisicao);
  }, [cboFormaPagto, txtDataIni, txtDataFim, buscaNotas, cboData]);

  const notas = chkSituacao
    ? notasFiscais.filter(
      nt => nt.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA,
    )
    : notasFiscais;

  const total = useMemo(() => {
    //   const valor = notas.reduce((tot, pag) => {
    //     return tot + Number(pag.vlr);
    // }, 0);

    const valor = notas.reduce((acc, current) => {
      if (current.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA) {
        return acc + Number(current.vlr);
      }
      return acc;
    }, 0);

    const canceladas =
      notas.filter(
        nota =>
          nota.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.CANCELADO,
      ).length || 0;

    const qtd = notas.length - canceladas;

    return { valor: formatPrice(valor), qtd };
  }, [notas]);

  return (
    <>
      <Container fluid className="mt-2">
        <header className="py-2">
          <h4 className="text-secondary pl-4"> Notas Fiscais </h4>
        </header>
        <br className="clearfix" />
        <div className="bg-white p-3 border rounded">
          <p className="text-secondary mb-0">
            Relatório de Notas Fiscais de Serviço
          </p>
          <br className="clearfix" />
          <form id="notaForm">
            <Row className="small">
              <Col md={2} className="form-group">
                <label htmlFor="CboData">
                  <b> Busca Data </b>
                </label>
                <select
                  name="CboData"
                  id="CboData"
                  className="form-control form-control-sm"
                  onChange={e => setCboData(e.target.value)}
                  value={cboData}
                >
                  <option value="1"> Data de pagamento </option>
                  <option value="2"> Data de emissão </option>
                </select>
              </Col>
              <Col md={2} className="form-group">
                <label className="mr-1" htmlFor="TxtDataIni">
                  <b>Data Inicio</b>
                </label>
                <input
                  name="TxtDataIni"
                  id="TxtDataIni"
                  type="date"
                  className="form-control form-control-sm"
                  onChange={e => setTxtDataIni(e.target.value)}
                  value={txtDataIni}
                />
              </Col>

              <Col md={2} className="form-group">
                <label className="mr-1" htmlFor="TxtDataFim">
                  <b>Data Fim</b>
                </label>
                <input
                  name="TxtDataFim"
                  id="TxtDataFim"
                  type="date"
                  className="form-control form-control-sm"
                  onChange={e => setTxtDataFim(e.target.value)}
                  value={txtDataFim}
                />
              </Col>

              <Col md={2} className="form-group">
                <label htmlFor="CboFormaPagto">
                  <b> Forma Pagto. </b>
                </label>
                <select
                  name="CboFormaPagto"
                  id="CboFormaPagto"
                  className="form-control form-control-sm"
                  onChange={e => setCboFormaPagto(e.target.value)}
                  value={cboFormaPagto}
                >
                  <option value=""> Todos </option>
                  {optionsFormasPagamento.optionFormaPagamento &&
                    optionsFormasPagamento.optionFormaPagamento
                      .filter(forma => !forma.isDisabled)
                      .map(forma => (
                        <option value={forma.label}> {forma.label} </option>
                      ))}
                </select>
              </Col>
              <Col md={2} className="form-group">
                <br /> <br />
                <input
                  type="checkbox"
                  name="ChkSituacao"
                  id="ChkSituacao"
                  onChange={e => setChkSituacao(e.target.checked)}
                />
                <label className="ml-2" htmlFor="ChkSituacao">
                  <b> Apenas emitidas </b>
                </label>
              </Col>
              <Col md={2} className="form-group">
                <br />
                <button
                  type="button"
                  name="CmdBuscar"
                  id="CmdBuscar"
                  className="btn btn-sm btn-primary mt-md-2"
                  onClick={() => BuscaNota()}
                  disabled={loading}
                >
                  {loading ? 'Carregando' : 'Buscar'}
                </button>
              </Col>
            </Row>
          </form>
          <span id="LblRespGrid" />
          <div>
            <div className="d-flex justify-content-end font-weight-bold p-3">
              <span>Quantidade: {total.qtd}</span>
              <span className="ml-5">Valor Total: {total.valor}</span>
            </div>
            <form id="formTable">
              <Table striped bordered hover size="sm" id="GrdConsulta">
                <tbody>
                  <tr className="bg-light">
                    <th>Nome</th>
                    <th>Serviço</th>
                    <th>Valor</th>
                    <th>Data Pagto</th>
                    <th>Data Emissão</th>
                    <th>Forma Pagto</th>
                    <th>Situação</th>
                    <th>RPS</th>
                    <th>Nota Fiscal</th>
                  </tr>
                  {notas.map(nota => {
                    return (
                      <ItemTabela
                        key={`${nota.CprCodigo}-${nota?.NfeId}`}
                        Item={nota}
                      />
                    );
                  })}
                  {/* <tr style={{ fontWeight: 'bold' }}>
                    <td colSpan={2} style={{ textAlign: 'right' }}>
                      Total
                    </td>
                    <td style={{ textAlign: 'right' }}>{formatPrice(total)}</td>
                    <td colSpan={5} style={{ textAlign: 'left' }} />
                  </tr> */}
                </tbody>
              </Table>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default RelatorioNotaFiscal;
